/* eslint-disable react/prop-types */
/* eslint-disable no-redeclare */
import React from "react";
import AboutBg from "../../Images/about.jpg";
import { aboutData } from "../../Data/Data";

const About = () => {
  return (
    <>
      <div className="p-0 m-0 box-border">
        <div className="w-[90%] mx-auto my-10">
          <div className="flex flex-col-reverse lg:flex-row justify-between gap-8 lg:gap-2 items-center font-Inter">
            <div className="w-full lg:w-[48%]">
              <h2 className="text-4xl font-semibold py-4">About Us</h2>
              <p className="font-medium text-xl">
              At PMC, we take pride in delivering on our promises. Our team consists of highly qualified and experienced experts, ensuring that we consistently provide exceptional quality and achieve the highest level of customer satisfaction upon project completion. Our project delivery methodology places our clients at the center of every stage, from planning to execution.


              </p>
            </div>
            <div className="w-full lg:w-[48%] ">
              <img src={AboutBg} alt="" className="rounded-md" />
            </div>
          </div>
        </div>
        <div className="bg-[#F7F8F8]">
          <div className=" w-[90%] mx-auto flex flex-col py-16 lg:flex-row gap-8 lg:gap-2 justify-between items-center ">
            {aboutData?.map((item) => (
              <div
                key={item.id}
                className=" w-[340px] sm:w-[390px] h-[240px]  bg-white font-Inter shadow-xl rounded-md"
              >
                <div className="w-[330px] mx-auto">
                  <h4 className="py-6 font-semibold text-3xl">{item.title}</h4>
                  <p className="font-medium">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
